import { Component, OnInit, Input, EventEmitter, Output } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { PaymentService } from '../../../services/payment.service';
import { ParameterService } from '../../../services/parameter.service';
import { environment } from '../../../../environments/environment';
import { Payment } from '../../../models/payment';
import { PaymenttechFormPopupComponent } from './paymenttech-form-popup/paymenttech-form-popup.component';
import { MatDialog } from '@angular/material';
import { PaymentModalReturn } from '../../../models/payment-modal-return';
import { TranslateService } from '@ngx-translate/core';

@Component({
  selector: 'app-paymenttech-form',
  templateUrl: './paymenttech-form.component.html',
  styleUrls: ['./paymenttech-form.component.css']
})
export class PaymenttechFormComponent implements OnInit {
  @Input() chamberId: string;
  @Input() paymentToken: string;
  @Input() source: string;
  @Input() userId: string;
  @Input() allowCardSaving: boolean;
  @Input() forceCardSaving: boolean;
  @Input() defaultCardSaving: boolean;

  @Output() paymentSucces: EventEmitter<any> = new EventEmitter();
  @Output() paymentError: EventEmitter<any> = new EventEmitter();

  loading: boolean;
  savingCard: boolean;

  private apiURL = environment.apiURL;
  private headers = new HttpHeaders({'Content-Type': 'application/json'});

  constructor(private http: HttpClient, private parameterService: ParameterService,
              private paymentService: PaymentService, public dialog: MatDialog, private translateService: TranslateService) { }

  ngOnInit() {
    this.savingCard = false;
    if (this.allowCardSaving && this.forceCardSaving) {
      this.savingCard = true;
    } else if (this.allowCardSaving && this.defaultCardSaving) {
      this.savingCard = this.defaultCardSaving;
    }
  }

  onClickPay() {
    this.loading = true;
    this.paymentService.getPayment(this.paymentToken, this.chamberId, this.savingCard)
    .then((payment: Payment) => {
      this.loading = false;
      //Show pop-up with paymentTech Iframe
      const dialogRef = this.dialog.open(PaymenttechFormPopupComponent, {
        width: '650px',
        data: payment.PaymentTechForm.UID
      });

      dialogRef.afterClosed().subscribe((result: PaymentModalReturn) => {
        if (result.ReturnType === 'complete') {
          this.loading = true;
          this.PostPaymentTechPayment(result.ReturnMessage, this.chamberId, this.paymentToken)
          .then(() => {
            this.loading = false;
            this.paymentSucces.emit(null);
          })
          .catch((reterror) => {
            this.loading = false;
            let errorMessage = '';

            if (reterror.Code) {
              switch (reterror.Code) {
                case 1:
                  errorMessage = this.translateService.instant('PaymentForm.PaymentTech.APIErrors.Fail');
                  break;
                case 2:
                  errorMessage = this.translateService.instant('PaymentForm.PaymentTech.APIErrors.Refund');
                  break;
                case 5:
                  errorMessage = this.translateService.instant('PaymentForm.PaymentTech.APIErrors.RefundFail');
                  break;
                case 3:
                  errorMessage = this.translateService.instant('PaymentForm.PaymentTech.APIErrors.Retry');
                  break;
                case 4:
                  errorMessage = this.translateService.instant('PaymentForm.PaymentTech.APIErrors.Error');
                  break;
                case 7:
                  errorMessage = this.translateService.instant('PaymentForm.PaymentTech.APIErrors.SystemFailure');
                  break;
                default:
                  break;
              }
            } else {
              errorMessage = this.translateService.instant('Generics.Error');
            }
            this.paymentError.emit(errorMessage);
          });
        } else if (result.ReturnType === 'error') {
          this.paymentError.emit(result.ReturnMessage);
        }
      });
    })
    .catch((error) => {
      this.loading = false;
      this.paymentError.emit(error);
    });
  }

  public PostPaymentTechPayment(uID: string, chamberId: string, paymentToken: string): Promise<any> {
    let callbackUrl = this.apiURL + 'payment/' + uID + '/paymenttech?chamberid=' + chamberId + '&paymenttoken=' + paymentToken;
    if (this.source && this.source.trim() !== '') {
      callbackUrl += '&paymentsource=' + this.source;
    }
    if (this.userId && this.userId.trim() !== '') {
      callbackUrl += '&userid=' + this.userId;
    }

    const callHeaders: HttpHeaders = this.headers;
    return this.http.post<any>(callbackUrl, null, {headers: callHeaders})
    .toPromise()
    .then(response => response)
    .catch(this.handleError);
  }

  private handleError(error: any): Promise<any> {
    console.error('An error occurred', error); // for demo purposes only
    return Promise.reject(error.error || error.message || error);
  }
}



// WEBPACK FOOTER //
// /home/ubuntu/MembriPay/src/app/components/payment/paymenttech-form/paymenttech-form.component.ts